// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"Video-module--playerWrapper--2--od","poster":"Video-module--poster--gWZUM","playButton":"Video-module--playButton--3zkhN","player":"Video-module--player--1FkDl"};